import { CategoryView } from './CategoryView';
import { Table, Button } from 'antd';
import { Category } from '@/types/categories/category';
import { CategoryColumn } from '@/components/columns/CategoryColumn';
import { useTranslation } from 'react-i18next';
import { PlusOutlined } from '@ant-design/icons';
import { CategoryModal } from '../utils/enums';
import { getCategoryMenu } from '@/components/menu';
import enUS from 'antd/locale/en_US';
import jaJP from 'antd/locale/ja_JP';

interface RightSidebarProps {
  categoryView: CategoryView;
  setCurrentCategory: (category: Category | null) => void;
  currentCategory: Category | null;
  setOpenModal: (modal: CategoryModal | null) => void;
}

export default function RightSidebar({
  categoryView,
  setCurrentCategory,
  currentCategory,
  setOpenModal,
}: RightSidebarProps) {
  const { t, i18n } = useTranslation();
  const antdLocale = i18n.language === 'ja-JP' ? jaJP : enUS;

  return (
    <div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          paddingBottom: '10px',
        }}
      >
        <h3>{t('home.categories.listTitle')}</h3>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => setOpenModal(CategoryModal.ADD)}
        >
          {t('home.categories.btnAdd')}
        </Button>
      </div>
      <Table
        columns={CategoryColumn(
          setCurrentCategory,
          setOpenModal,
          getCategoryMenu,
          t,
        )}
        dataSource={categoryView.categories}
        rowKey="id"
        pagination={{
          current: categoryView.currentPage,
          pageSize: categoryView.pageSize,
          total: categoryView.total,
          showSizeChanger: true,
          showTotal: total => t('pagination.total', { total }),
          locale: antdLocale.Pagination,
          onChange: (page, pageSize) => {
            categoryView.loadCategories({ page, page_size: pageSize });
          },
        }}
        onRow={record => ({
          onClick: () => setCurrentCategory(record),
          style: {
            cursor: 'pointer',
            backgroundColor:
              currentCategory?.id === record.id ? '#f0f0f0' : 'transparent',
          },
        })}
      />
    </div>
  );
}
